import React from "react";
import SEO from "../../components/SEO";
import {convertToBoolean} from "../../utils/string.utils";
import logo from "../../assets/Logo/logo_validation.png";
import {useAuth} from "oidc-react";

const pageSEOSettings = {
    title: "AccessDenied",
};

const {
    REACT_APP_SETTINGS_SHOW_LOGO,
    REACT_APP_SLIPWAY_URL
} = process.env;

const AccessDenied = () => {
    const auth = useAuth();
    return (
        <div>
            <SEO {...pageSEOSettings} />
            <div className="grid grid-cols-12 h-screen">
                <div className="col-span-12 bg-[var(--primary-color)] h-full">
                    <div className="grid grid-cols-12 pl-16 h-full ">
                        <div className="col-span-12 border-l border-[#5F7A7F] py-32">
                            <div className="grid grid-cols-12  h-full ">
                                <div className="col-span-2 -ml-[100%] h-full">
                                    <div className="flex ">
                                        <div className=" border-t border-[#5F7A7F] w-[45%]"></div>
                                        <div className=" bg-[var(--primary-color)] -mt-3 p-3 w-[40%]"></div>
                                    </div>
                                </div>
                                <div className="col-span-10">
                                    <div className="ml-[-36%] mt-[-4%]">
                                        <div
                                            className="text-[var(--secondary-color)] text-[42px] pl-5 ml-[18%] font-family: Amina;">
                                            ValidationStation
                                        </div>
                                        {(convertToBoolean(REACT_APP_SETTINGS_SHOW_LOGO) &&
                                            <>
                                                <div
                                                    className="text-[var(--secondary-color)] text-[12px] pl-6 ml-[19%] -mt-1 flex font-family: Amina;">
                                                    Part of
                                                    <span className="m-[5px] -mt-[-2px] ">
                                                <img src={logo} alt=""/>
                      </span>
                                                </div>
                                            </>

                                        )}
                                    </div>
                                </div>
                                <div className="col-span-12 ">
                                    <div>
                                        <div className="text-5xl text-[#FFFFFF] pt-32 pl-5 font-normal ml-[7%]">
                                            Access Denied
                                        </div>
                                        <div className="text-2xl text-[#FFFFFF] pt-10 pl-5 font-normal ml-[7%]">
                                            You do not have permissions to the selected resource. Please contact your system administrator.
                                        </div>
                                        <div
                                            style={{display: "inline-flex", justifyContent: "space-between", alignItems: "center"}}
                                            className={"ml-[5%] mt-10"}>
                                            <div
                                                onClick={() => { window.location.href = REACT_APP_SLIPWAY_URL}}
                                                className="cursor-pointer box-border flex flex-row justify-center items-center text-sm font-normal text-[black] gap-2.5 ml-[10%] mt-[5%]  w-[244px] h-10 border p-2.5 rounded-[50px] border-solid border-[#020A08] bg-[#FFFFFF]"
                                            >
                                                <button type="submit">Slipway
                                                </button>
                                            </div>
                                            <div
                                                onClick={() => {auth.signOutRedirect()}}
                                                className="cursor-pointer box-border flex flex-row justify-center items-center text-sm font-normal text-[black] gap-2.5 ml-[10%] mt-[5%]  w-[244px] h-10 border p-2.5 rounded-[50px] border-solid border-[#020A08] bg-[#FFFFFF]"
                                            >
                                                <button type="submit">Logout</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-12"></div>
                                </div>
                                <div className="col-span-12 h-full   border-b border-[#5F7A7F] -ml-[102%] pb-[0.3rem]">
                                    <div className="h-full   flex items-end"></div>
                                    <div className="h-6 w-[1.2%]    ml-[50%] -mt-1.5">
                                        <div className="  h-full  bg-[var(--primary-color)] ml-[-0.3rem]"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;